import * as types from '../mutation-types'

const state = {
	all: [],
	active: {
		id: null,
		name: '',
		profile: 0,
		duration: 0,
		type: 1,
		dailyData: {
			data: []
		}
	}
}

const mutations = {
	[types.SET_PROFILES](state, profiles) {
		state.all = profiles;
	},

	[types.SET_ACTIVE_PROFILE](state, profile) {
		state.active = profile;
	},

	[types.ADD_PROFILE](state, profile) {
		state.all.push(profile);
	}
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/profiles.js